import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-black pt-20 flex items-center justify-center">
      <div className="container mx-auto px-4 max-w-lg">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-[#09090b] border border-white/10 p-12 text-center"
        >
          <div className="w-20 h-20 bg-[#EF4444]/20 mx-auto mb-6 flex items-center justify-center">
            <XCircle size={40} className="text-[#EF4444]" />
          </div>
          <h1 
            className="font-['Teko'] text-4xl text-white mb-4"
            data-testid="payment-cancel-title"
          >
            PAIEMENT ANNULÉ
          </h1>
          <p className="font-['Barlow'] text-gray-400 mb-8">
            Votre paiement a été annulé. Aucun montant n'a été débité de votre compte. 
            Vous pouvez réessayer quand vous le souhaitez.
          </p>
          <div className="flex flex-col gap-4">
            <Link to="/trainings">
              <Button className="w-full bg-[#FACC15] text-black font-bold uppercase tracking-wider hover:bg-[#EAB308]">
                <ArrowLeft size={18} className="mr-2" />
                Retour aux formations
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
                Besoin d'aide ?
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancel;
